export function getSizeAsMb(size: number) {
  return size / 1024 / 1024;
}

export function getFilesFromDrop(event: any): File[] {
  const fileList: File[] = [];
  if (event.dataTransfer.items) {
    [...event.dataTransfer.items].forEach((item, i) => {
      if (item.kind === 'file') {
        const file = item.getAsFile();
        fileList.push(file);
      }
    });
  }
  return fileList;
}

export function getExtension(fileName: string) {
  return fileName.split('.').pop();
}

export const getFileName = (file: File) => file.name;

export function base64ToBlob(b64Data: string, sliceSize = 512) {
  let byteCharacters = atob(b64Data);
  let byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    let slice = byteCharacters.slice(offset, offset + sliceSize);

    let byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    let byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  return new Blob(byteArrays, {
    type: 'application/pdf',
  });
}

export function downloadFile(base64: string, fileName: string): void {
  const archivo = base64ToBlob(base64);
  const urlArchivo = URL.createObjectURL(archivo);
  const linkDescarga = document.createElement('a');
  linkDescarga.href = urlArchivo;
  linkDescarga.download = fileName;
  document.body.appendChild(linkDescarga);
  linkDescarga.click();
}

export const downloadBlobFile = (
  blob: Blob,
  fileName: string,
  openOnDownload = false
): void => {
  const urlArchivo = URL.createObjectURL(blob);
  const linkDescarga = document.createElement('a');
  linkDescarga.href = urlArchivo;
  linkDescarga.target = openOnDownload ? '_blank' : '_self';
  linkDescarga.download = fileName;
  document.body.appendChild(linkDescarga);
  linkDescarga.click();
};
